var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"ftr"},[_c('div',{staticClass:"ftr__main container"},[_c('app-footer-top',{attrs:{"referral-source":_vm.referralSource}}),_vm._v(" "),_c('span',{staticClass:"section-break"}),_vm._v(" "),_c('app-footer-bottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }